<template>
<div>

  <v-select 
    ref="initialbox"
    v-model="initial"
    :options="initialList"
    label="Description"
    @search="onInitialInput"
    placeholder="What would you like help with?"
  ></v-select>

</div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import SearchService from '@/services/SearchServices'
const searchService = new SearchService()

export default {
  components: {
    'v-select': vSelect
  },
  data() {
    return {
      initial: null,
      initialList: [],
      initialSearchString: ''
    }
  },
  methods: {
    async onInitialInput(searchStr, loadingCallback) {
      this.initialSearchString = searchStr

      loadingCallback(true)
      var response = await searchService.initialSearch(searchStr.trim())
      loadingCallback(false)
      
      this.initialList = response.data.results[0]?.Levels || []
    }
  },
  mounted() {

  }
}
</script>
